import React, { useCallback, useEffect, useState } from "react";
import {getData, postData} from '../middleware/apiMiddleware';
import s from './ItemQuestionsOverview.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function ItemQuestions(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [qtns, setQtns] = useState([]);
	
	/* -------- item only -------- */	
	const fetchItemQtns = () => {
		getData('item/listItemQtns?itemId=' + itemId, navigate)
		.then(res => {
				let questions = res.data;
				
				for(let q of questions) {
					q.id = q.id.toString();
				}
				setQtns(questions);
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		fetchItemQtns();
	}, [itemId]);
	
	const updateItemQtnsOrdering = (newQtns) => {
		let objs = [];
		
		for (let i = 0; i < newQtns.length; i++) {
			objs.push({id:newQtns[i].id, ordering:i});
		}
		
		let param = {
			itemId,
			qtns:objs
		}
		
		postData("item/updateItemQtnsOrdering", param, navigate); 
	}
	
	const onDragEnd = async (result) => {
    if (!result.destination) return;
    const newQtns = Array.from(qtns);
    const [removed] = newQtns.splice(result.source.index, 1);
    newQtns.splice(result.destination.index, 0, removed);
		updateItemQtnsOrdering(newQtns);
    setQtns(newQtns);
  };
	
	if (!fetchCompleted) {
		return (<MyComponentLoading/>)
	}
	
	return (<div>

		
		
		{
			<DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="qtns">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} 
						style={{display:"flex", flexDirection:"column", gap:"2px", flexWrap: "wrap", alignItems:"center"}}>
            {qtns.map((qtn, index) => (
              <Draggable key={qtn.id} draggableId={qtn.id} index={index}>
                {(provided) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}>
										<QtnDisplay index={index} q={qtn} />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
			
			
		}
		
	</div>);
	
}

const QtnDisplay = ({index, q}) => {
	
	return (<div style={{border:"1px solid #22222222", 
		fontSize:"0.8rem", 
		 textAlign:"left", padding:"10px", ...qcTypeStyle(q.qcType)}}>
		<div style={{display:"flex"}}>
			<div>Q{index+1} - {q.id}</div>
			<div style={{margin:"0 0 0 auto"}}>{q.qcType}[{qcTypeLabel(q.qcType)}]</div>
			{(q.qcType == 51) && (<div>({q.separatorType})</div>)}
		</div>
		<div>{q.question} </div>
		<div>{q.prefix} <span style={{color:"red"}}>{q.answer}</span> {q.suffix}</div>	
	</div>);
}

function qcTypeStyle(qcType) {
		switch(qcType) {
			case 30: //MC
			case 31: 
			case 47: 
			case 48:
			case 49:
			case 50:
				return {width:"800px"}//"#8faeae";
			case 51: //separator
				return {fontSize:"1rem", fontWeight:"bold", width:"1000px", background:"#bcd1f5"};
			case 56:
			case 38:
			case 39: 
				return {width:"800px"}//"Fill-in-the-blank";
			case 40:
			case 41: 
				return {width:"800px"}//"Dropdown box";
			case 42:
			case 43: 
			case 44:
			case 45: 
				return {width:"800px", border:"2px dashed #95c7ba"}//"Paragraph(Fill-in)";
			case 46: 
				return {border:"5px double #bcdcf5", width:"850px"}//"Open";
		}
		
		return {width:"800px"}//
}

function qcTypeWidth(qcType) {
		switch(qcType) {
			case 51: //separator
				return "1000px";
		}
		
		return "800px"
}


function qcTypeBackgroundColor(qcType) {
		switch(qcType) {
			case 30: //MC
			case 31: 
			case 47: 
			case 48:
			case 49:
			case 50:
				return "#8faeae";
			case 51: //separator
				return "#bcd1f5";
			case 56:
			case 38:
			case 39: 
				return "Fill-in-the-blank";
			case 40:
			case 41: 
				return "Dropdown box";
			case 42:
			case 43: 
			case 44:
			case 45: 
				return "Paragraph(Fill-in)";
			case 46: 
				return "Open";
		}
		
		return ""
}


	function qcTypeLabel(qcType) {
		switch(qcType) {
			case 30:
			case 31: 
				return "MC";
			case 47: //MC audio
				return "MC audio";
			case 48: //MC image
				return "MC image";
			case 49: //MC meaning
				return "MC meaning";
			case 50: //MC meaning
				return "MC meaning HK";
			case 51: //separator
				return "Separator";
			case 56:
			case 38:
			case 39: 
				return "Fill-in-the-blank";
			case 40:
			case 41: 
				return "Dropdown box";
			case 42:
			case 43: 
				return "Paragraph";
			case 44:
			case 45: 
				return "Paragraph(Fill-in)";
			case 46: 
				return "Open";
		}
		
		return "?"
	}